'use client'
import { Modal, ModalOverlay, ModalContent } from '@chakra-ui/react'
import React, { useState, useEffect } from 'react'
import { How } from './individual/stripe_experience/how'
import UnderReview from '../breakdown-popups/underreview'
import { StripePersonalDetailsModal } from '../stripeConnect/personalDetailsModal'
import { useGetStripeOnboardingAccountDataMutation, useUpdateStripeOnboardingAccountMutation } from '@/src/mutations/stripeOnboarding/create-onboarding-account'
import { toast } from 'sonner'
import { useUser } from '@/src/store/user-store'

const VERIFICATION_FEES: Record<string, number> = {
  IN: 10,
  US: 300,
  GB: 300,
  CA: 300,
  AE: 200,
}

export default function StripeIndividual({
  isOpen,
  onClose,
  currentStep,
  setCurrentStep,
}: {
  isOpen: boolean
  onClose: () => void
  currentStep: number
  setCurrentStep: (value: number) => void
}) {
  const { user } = useUser();
  const verificationFee = VERIFICATION_FEES[user?.countryShortname ?? ''] ?? 0
  const verificationFeeInUsd = (verificationFee * 0.02).toFixed(2)
  const updateStripeData = useUpdateStripeOnboardingAccountMutation()
  const getStripeUserData = useGetStripeOnboardingAccountDataMutation()
  const handleHowContinue = () => {
    setCurrentStep(1)
  }

  const handlePersonalDetailsSuccess = () => {
    setCurrentStep(2)
    fetchUserData()
  }

  const handleVerificationSuccess = () => {
    setCurrentStep(3)
  }
  const onboardStripeUser = async()=>{
    await updateStripeData.mutate(
       {
         isOnboard: '1',
         StripeAccountId: user?.StripeAccountId,
       },
       {
         onError: (error) => {
           toast.error(error.message)
         },
         onSuccess:  () => {
          
         },
       }
     )
   }
const fetchUserData = async () => {
    try {
      await getStripeUserData.mutate(
        {
          StripeAccountId: user?.StripeAccountId||"",
        },
        {
          onError: (error) => {
            return ''
          },
          onSuccess: (e) => {
            if(e?.payouts_enabled === true){
              onboardStripeUser()
            }
            
          },
        }
      )
    } catch (error) {
      console.error('Error fetching client secret!', error);
      return ''
    }

  };
  return (
    <Modal
      scrollBehavior="inside"
      isOpen={isOpen}
      onClose={()=>{
        onClose();
        window.location.reload()
      }}
      size={'lg'}
      isCentered
    >
      <ModalOverlay />
      <ModalContent>
        {currentStep === 0 && <How onContinue={handleHowContinue} />}
        {currentStep === 1 && (
          <StripePersonalDetailsModal
            onSuccess={handlePersonalDetailsSuccess}
            handleVerificationSuccess={handleVerificationSuccess}
          />
        )}
        {currentStep === 2 && (
          <UnderReview
            onClose={()=>{
              onClose();
              window.location.reload()
            }}
            msg="ID Verification Completed!"
            subtitle={`ID verification is under review. Please check back later to redeem your earnings! ${verificationFee} LYK Coins (US$ ${verificationFeeInUsd}) have been debited from your wallet for verification.`}
          />
        )}
      </ModalContent>
    </Modal>
  )
}
